//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

import ReportImagesRemark from './ReportImagesRemark.vue'
import FilesGroup from '../../components/File/FilesGroup.js'
import FilesField from '../../components/File/FilesField'
import { reportFiles } from './ReportFiles'
import ReportContentSection from './ReportContent/ReportContentSection.vue'

export default {
  components: {
    ReportImagesRemark,
    FilesField,
    ReportContentSection
  },
  mixins: [reportFiles],
  data: function () {
    return {
      FILES_PROPERTY: 'guiDocFiles', // !!!
      categories: [
        new FilesGroup({ categoryKey: 'dispatcher', title: 'ВЛОЖЕНИЯ ИЗ ЗАЯВКИ', readonly: true }),
        new FilesGroup({ categoryKey: 'afterWorkExecution', title: 'ПОСЛЕ ВЫПОЛНЕНИЯ РАБОТ', readonly: false })
      ],
      expansionCategories: {}
    }
  },
  computed: {
    ...mapGetters({
      getSectionIcon: 'reportContent/getSectionIcon'
    })
  },
  created: function () {
    const filesGroupsContainer = this.report.filesGroupsContainers[this.FILES_PROPERTY]
    filesGroupsContainer.addFilesGroups(this.categories.slice())
    this.filesGroupsContainer = filesGroupsContainer

    this.categoriesMap = Object.fromEntries(this.categories.map(filesGroup => [filesGroup.key, filesGroup]))

    let allFilesNumber = 0
    if (this.report.documents) {
      allFilesNumber = this.pushFiles(this.report.documents)
    }

    this.categories.forEach(category => {
      if (category.files.length > 0) {
        this.$set(this.expansionCategories, category.key, true)
        this.categoriesCollapsePanel.push(category.key)
      } else {
        this.$set(this.expansionCategories, category.key, false)
      }
    })

    this.$nextTick(() => {
      this.initialized = true
      this.$nextTick(() => {
        this.$emit('update:files-number', allFilesNumber)
      })
    })
  },

  methods: {
    getDocCategoryIcon (categoryKey) {
      if (typeof this.getSectionIcon !== 'function') {
        return null
      }
      return this.getSectionIcon(`report-doc-category-${categoryKey}`)
    },
    onDocCategoryOpenChange (categoryKey, val) {
      this.$set(this.expansionCategories, categoryKey, !!val)
    }
  }
}

